export default __webpack_public_path__ + "static/media/slider3-6items.a2bc2984.svg";